/**
 * gamePlayNavigation — Small route helpers for GamePlay end-screens.
 *
 * The end-of-game screens (Won / Lost) all share the same "where do I go next?"
 * branching logic. Centralising it here removes 6+ inline ternaries from
 * GamePlay.jsx and ensures every mode routes consistently.
 */

/**
 * Where to send the user when they pick "Other game / Robot / Opponent".
 * @param {string} mode - current play mode (training | competition | eliminatoria | vs_robot | vs_human)
 * @param {URLSearchParams} params - current URL query string
 */
export function getOtherGameRoute(mode, params) {
  // VS Robot duel inside an eliminatoria → back to the elim lobby.
  if (mode === "vs_robot" && params?.get?.("elim")) return "/eliminatorias/lobby";
  if (mode === "eliminatoria") return "/eliminatorias/lobby";
  if (mode === "vs_robot") return "/vs-robot";
  if (mode === "vs_human") return "/vs-humano";
  // Grande Final training → back to the GF game picker, not the VS Tempo one.
  if (mode === "training" && params?.get?.("gf") === "1") return "/treino/grande-final";
  return "/treinar";
}

/**
 * Where to send the user when they hit the "Sair" button.
 * VS Robot elim duels go back to the lobby (not to /vs-robot).
 */
export function getExitRoute(mode, params) {
  if (mode === "vs_robot" && params?.get?.("elim")) return "/eliminatorias/lobby";
  if (mode === "vs_robot") return "/vs-robot";
  if (mode === "vs_human") return "/vs-humano";
  return "/";
}

/**
 * Where to send the user when they hit the "Voltar" button (back to the
 * PREVIOUS menu, without logging out). Unlike `getExitRoute`, training and
 * competition stay inside the play area instead of returning to "/".
 */
export function getBackRoute(mode, params) {
  if (mode === "vs_robot" && params?.get?.("elim")) return "/eliminatorias/lobby";
  if (mode === "eliminatoria") return "/eliminatorias/lobby";
  if (mode === "vs_robot") return "/vs-robot";
  if (mode === "vs_human") return "/vs-humano";
  if (mode === "competition") return "/competir";
  if (mode === "training" && params?.get?.("gf") === "1") return "/treino/grande-final";
  return "/treinar";
}
